<template>
  <b-dropdown
    :value="value"
    @input="(value) => $emit('input', value)"
    aria-role="list"
    :multiple="multiple"
    :class="$style.dropdownContainer"
  >
    <button class="button" :class="$style.triggerButton" slot="trigger">
      <span class="text-input">
        {{ value ? renderLabel(value) : '' }}
      </span>
      <b-icon type="is-black" icon="menu-down" size="is-small"></b-icon>
    </button>

    <b-dropdown-item
      v-for="(item, index) in options"
      :value="item"
      :key="`options${index}`"
    >
      {{ item.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

interface Options {
  label: string;
  value: string | number;
}

@Component({
  components: {},
})
export default class BaseDropDown extends Vue {
  @Prop({ default: [] })
  public options!: Options[];

  @Prop({ default: false })
  public multiple!: boolean;

  @Prop()
  public value!: string | string[];

  public renderLabel(values: Options | Options[]) {
    if (Array.isArray(values)) {
      return values.map(({ label }) => label).join(', ');
    }

    return values.label;
  }
}
</script>

<style lang="scss" module>
.dropdownContainer {
  :global(.dropdown-menu) {
    padding-top: 0;

    :global(.dropdown-content) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.triggerButton {
  width: 100%;
  justify-content: space-between;
}
</style>
